"use client";
import * as React from "react";
const SvgShoppingCartSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.37 12.8c-.85 0-1.54.72-1.54 1.6s.69 1.6 1.54 1.6 1.54-.72 1.54-1.6-.7-1.6-1.54-1.6m-7.73 0c-.85 0-1.54.72-1.54 1.6S3.79 16 4.64 16s1.54-.72 1.54-1.6-.7-1.6-1.54-1.6m0-2.4.85-1.6h5.76c.58 0 1.09-.33 1.35-.82L16 1.6H3.25L2.53 0H0v1.6h1.55l2.78 6.07L2.03 12H13.9v-1.6z" }));
export {
  SvgShoppingCartSharp as default
};
